/**
 * 매장 쿠폰 발급 뮤테이션. store 도메인에서만 사용.
 *
 * autoFulfillConditions: true 이면 서버가 미충족 조건(좋아요 등)을 자동 충족 후 발급.
 */
import { gql } from "@apollo/client";

export const ISSUE_STORE_COUPON = gql(`
  mutation IssueStoreCoupon($couponId: Int!, $autoFulfillConditions: Boolean) {
    issueStoreCoupon(couponId: $couponId, autoFulfillConditions: $autoFulfillConditions) {
      ok
      error
      unmetConditions {
        type
      }
      userCoupon {
        id
        userId
        couponId
        isUsed
        expiredAt
        issuedAt
        coupon {
          id
          title
          discountValue
          minOrderPrice
        }
      }
    }
  }
`);
